// مسیر: frontend/src/services/mediaService.js (نسخه نهایی و اصلاح شده)

import { useState, useEffect, useCallback } from 'react';
// 💡 ۱. استفاده از نمونه 'api' (که توکن را تزریق می‌کند)
import api from './api'; 

// 🟢 ۲. اصلاح مسیرهای ایمپورت (از ../../ به ../)
import { MEDIA_BASE_URL } from '../config';
// 🛑 ایمپورت openAuthModal برای مدیریت خطای 401
import { useAuthContext } from '../context/AuthContext'; 

// ----------------------------------------------------
// ۳. Export کردن هوک (Hook)
// ----------------------------------------------------
export const useSecureMedia = (mediaId) => {
    const [mediaUrl, setMediaUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    
    // 🛑 دریافت isLoggedIn و openAuthModal
    const { isLoggedIn, openAuthModal } = useAuthContext();

    const fetchMediaUrl = useCallback(async (id) => {
        
        // 🛑 FIX: شرط !isLoggedIn حذف شد. اگر محتوا رایگان باشد، بک‌اند به ما URL را می‌دهد.
        if (!id) {
            setMediaUrl(null); 
            return;
        }

        setIsLoading(true);
        setError(null);

        try {
            // 🟢 این درخواست اکنون با توکن (اگر کاربر لاگین است) یا بدون توکن (اگر لاگین نیست) ارسال می‌شود.
            const response = await api.get(`/products/protected-url/${id}/`);
            
            if (response.data && response.data.presigned_url) {
                // حالت S3 (Production)
                setMediaUrl(response.data.presigned_url);
            } else if (response.data && response.data.media_url) {
                // حالت توسعه لوکال
                setMediaUrl(MEDIA_BASE_URL + response.data.media_url);
            } else {
                 throw new Error("پاسخ سرور فاقد URL بود.");
            }

        } catch (err) {
            console.error("Error fetching secured URL:", err);
            
            if (err.response && err.response.status === 401) {
                // 🛑 FIX: باز کردن مدال لاگین بجای هدایت به صفحه
                openAuthModal(); 
                setError("خطای احراز هویت: لطفاً وارد شوید.");
            } else if (err.response && err.response.status === 403) {
                setError("خطای مجوز: شما دسترسی لازم برای مشاهده این فایل را ندارید.");
            } else {
                setError(err.message || "خطا در بارگذاری مدیا");
            }
        } finally {
            setIsLoading(false);
        }
    // 🛑 openAuthModal به وابستگی‌ها اضافه شد
    }, [openAuthModal]); 

    // افکت برای واکشی خودکار هنگام تغییر mediaId
    useEffect(() => {
        // 💡 اکنون این تابع در زمان mount اجرا می‌شود و اگر mediaId رایگان باشد، URL را می‌گیرد.
        // اگر خریدنی باشد، 401 می‌گیرد.
        fetchMediaUrl(mediaId);
    }, [mediaId, fetchMediaUrl]);

    // بازگرداندن مقادیر و تابع واکشی دستی
    return { mediaUrl, isLoading, error, refetch: fetchMediaUrl };
};

// ----------------------------------------------------
// ۵. Export کردن تابع (برای PDFViewer)
// ----------------------------------------------------
export const getSecureMediaUrl = (mediaId) => {
    return `${api.defaults.baseURL}products/protected-url/${mediaId}/`;
};

// ----------------------------------------------------
// ۶. Export کردن Default (اختیاری)
// ----------------------------------------------------
const mediaService = {
    useSecureMedia,
    getSecureMediaUrl
};

export default mediaService;